package com.swetdot.swetgram.data.streaks

import com.swetdot.swetgram.data.api.ApiClient
import com.swetdot.swetgram.data.newUuid
import com.swetdot.swetgram.domain.SquadStreakDomain
import com.swetdot.swetgram.domain.SquadStreakParticipantDomain
import com.swetdot.swetgram.domain.SquadStreakTypeDomain
import com.swetdot.swetgram.protocol.dto.NudgeSquadStreakResponse
import com.swetdot.swetgram.protocol.dto.SquadStreak
import com.swetdot.swetgram.protocol.dto.SquadStreakParticipant
import com.swetdot.swetgram.protocol.dto.SquadStreakType
import com.swetdot.swetgram.protocol.dto.StartSquadStreakRequest
import io.ktor.client.request.setBody

class SquadStreakRepository(
    private val api: ApiClient,
) {
    suspend fun getStreak(conversationId: String): SquadStreakDomain? {
        return runCatching {
            val response = api.get<SquadStreak>("conversations/$conversationId/streak")
            response.toDomain()
        }.getOrNull()
    }

    suspend fun startStreak(conversationId: String): SquadStreakDomain {
        val clientId = newUuid()
        val response = api.post<SquadStreak>(
            path = "conversations/$conversationId/streak/start",
            idempotencyKey = clientId,
        ) {
            setBody(StartSquadStreakRequest(clientId = clientId, conversationId = conversationId))
        }
        return response.toDomain()
    }

    suspend fun nudge(conversationId: String): Boolean {
        val clientId = newUuid()
        val response = api.post<NudgeSquadStreakResponse>(
            path = "conversations/$conversationId/streak/nudge",
            idempotencyKey = clientId,
        )
        return response.notified
    }
}

private fun SquadStreak.toDomain() = SquadStreakDomain(
    id = id,
    conversationId = conversationId,
    type = when (type) {
        SquadStreakType.DUO -> SquadStreakTypeDomain.DUO
        SquadStreakType.GROUP -> SquadStreakTypeDomain.GROUP
        SquadStreakType.UNKNOWN -> SquadStreakTypeDomain.UNKNOWN
    },
    currentStreak = currentStreak,
    longestStreak = longestStreak,
    todayTargetMet = todayTargetMet,
    participants = participants.map(SquadStreakParticipant::toDomain),
    updatedAt = updatedAt,
)

private fun SquadStreakParticipant.toDomain() = SquadStreakParticipantDomain(
    userId = userId,
    stepsCount = stepsCount,
    messagesSent = messagesSent,
    targetMet = targetMet,
)
